import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { QRCodeSVG } from 'qrcode.react';
import md5 from 'crypto-js/md5'
import { route } from 'preact-router';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';
import { openUserProfileDrawer } from '../../lib/userProfile';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';
import ImageScroller from '../../components/imagescroller';
import InspectionStatus from '../../components/inspection/status';
import GuiList from '../../components/gui/list';
import PresenceDot from '../../components/gui/presenceDot';
import JuniorBadge from './juniorBadge';

function displayImg(img, props, size = '150x') {
    if (typeof img !== 'object') {
        return undefined;
    }
    const imgSrc = `${img.s3MediumLink}`;
    return imgSrc;
}

@withText(props => ({
    titleText: <Text id='race-class-contestants.title'>Race Contestants</Text>,
}))
@observer
class RaceClassContestantList extends Component {
  	constructor(props) {
        super(props);
        this.state = {
        };
    }

    viewRaceClassContestant = e => {
        const { view } = this.props;
        if (view) {
            return view(e);
        }
        const { id, title } = e.target.closest('.box-line').dataset;
        const { appState } = this.props.stores;
        const { drawerLevel = 1 } = this.props;
        const { drawerHeightMedium } = appState;
        // console.log('viewPart', { id });
        appState.openDrawer('viewRaceClassContestant', {
            id,
            // title,
            height: drawerHeightMedium,
            editFunction: this.editMediaViaView,
            callback: () => {
                appState.toggleDrawer();
                // this.loadAll();
            },
        }, drawerLevel + 1);
    }

    sortByTotal = (a, b) => {
        const { raceClassContestantStore } = this.props.stores;
        const { countriesTotal } = raceClassContestantStore;
        return countriesTotal[b] - countriesTotal[a];
    }

    render() {
        const { appState, userStore, raceStore, raceClassContestantStore, presenceStore } = this.props.stores;
        const { isDevelopment, path, apiServer } = appState;
        const { user, isAdmin } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');
        const { countries } = raceClassContestantStore;
        const { titleText } = this.props;
        const {
            raceClassContestants,
            classNames = '',
            hideEmpty,
            title = titleText,
            editElement,
            showCevron,
            raceClass,

            rightBoxField = 'distance',
            rightBoxFieldValue = e => e,
            rightBoxFieldPostfix = 'km',
            rightBoxFieldPostfixField = 'startDate',
            rightBoxFieldPostfixValue = e => util.formatDate(e, { year: 'numeric', locale: 'nb-NO' }, true),
            help,
        } = this.props;

        return (<>
            <GuiList
                stores={this.props.stores}
                holdingStore={raceStore}
                classNames={classNames}
                view={this.viewRaceClassContestant}
                title={title}
                list={raceClassContestants}
                qty={e => e.bib > 0 ? e.bib : undefined}
                qtyStyle={'width: 65px;'}
                elIconFunc={e => <>
                    {e.country && localUtil.getFlagSvg(e.country, 30, false, 'rounded', 'border: 1px solid #ffffff;')}
                </>}
                elTitle={e => (<>
                    {e.user > 0 ? <span
                        style='cursor: pointer;'
                        onClick={(event) => {
                            event.stopPropagation();
                            openUserProfileDrawer(this.props.stores.appState, {
                                userId: e.user,
                                name: `${e.firstname} ${e.lastname}`,
                            });
                        }}
                    >{e.firstname} {e.lastname}{presenceStore.track(e.user)}<PresenceDot online={presenceStore.onlineByUserId[e.user]} size={8} inline /></span> : `${e.firstname} ${e.lastname}`}
                    <JuniorBadge contestant={e} />
                </>)}
                elInfo1={e => e.birth ? util.age(e.birth) : ''}
                elInfo2={e => e.sportsClub}
                elInfo3={e => ''}
                hideEmpty={hideEmpty}
                editElement={editElement}
                showEmptyImage={false}
                showCevron={showCevron}
                rightBoxField={rightBoxField}
                rightBoxFieldValue={rightBoxFieldValue}
                rightBoxFieldPostfix={rightBoxFieldPostfix}
                imgHeight='60px'
                help={help}
            >
                {countries && countries[raceClass.id] && <>
                    <div class='d-flex flex-row justify-content-center position-absolute overflow-auto no-scrollbar' style='top: -45px; right: 0px; max-width: 50%;'>
                        {Object.keys(countries[raceClass.id]).map(country => {
                            return (<>
                                <div class='d-flex flex-row justify-content-center align-items-center position-relative'>
                                    {localUtil.getFlagSvgByCountryCode(country, 45, false, 'rounded-lg', 'border: 2px solid #ffffff;')}
                                    <div class='position-absolute bg-primary text-white rounded-lg px-2' style='bottom: 0px; left: 0px; line-height: 16px; border: 2px solid #ffffff;'>
                                        <small>
                                            {countries[raceClass.id][country]}
                                        </small>
                                    </div>
                                </div>
                            </>);
                        })}
                    </div>
                </>}
            </GuiList>
        </>);
    }
}

export default RaceClassContestantList;
